<script>
    import { Router, Route } from "svelte-routing";

    import { SvelteToast } from "@zerodevx/svelte-toast";

    import Main from "./routes/Main.svelte";
    import Lobby from "./routes/Lobby.svelte";
    import Game from "./routes/Game.svelte";
    import Playground from "./routes/Playground.svelte";
    import { basepath } from "./misc/routes";

    export let url = "";

    const svelteToastOptions = {};

    if (
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith(basepath)
    ) {
        window.location.replace(
            `${basepath}${window.location.pathname}${window.location.search}${window.location.hash}`
        );
    }
</script>

<Router {url} {basepath}>
    <div>
        <Route path="/">
            <Main />
        </Route>
        <Route path="/lobby">
            <Lobby />
        </Route>
        <Route path="/game">
            <Game />
        </Route>
        <Route path="/playground">
            <Playground />
        </Route>
    </div>
</Router>

<SvelteToast {svelteToastOptions} />
